import { Component, Vue } from 'vue-property-decorator';

@Component
export default class RenounceButton extends Vue {
  /**
   * Redirect the user to the alternative questionnaire
   */
  protected renounce(): void {
    this.$emit('giveUpClicked');
    this.$store.dispatch('setGiveUpClicked', true);
  }
}
